import { WorkflowStage } from '../types/Workflow';
import { FormBuilderAction } from '../../FormBuilder/types/FormBuilderAction';
import { convertApiActionsToBuilderActions } from '../../FormBuilder/utils/convertApiActionsToBuilderActions';

export const getStepActionsForStage = (stage: WorkflowStage): FormBuilderAction[] => {
  const actions = stage.steps.flatMap((step) => step.actions);
  return convertApiActionsToBuilderActions(actions);
};
